// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1GGhj","colMaxWidth":"Table_colMaxWidth__3VRgk"};